import { BrowserRouter, MemoryRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

interface AppProps {
  location?: string;
}

function App({ location }: AppProps) {
  const Router = location ? MemoryRouter : BrowserRouter;
  const routerProps = location
    ? { initialEntries: [location] }
    : { basename: __BASE_PATH__ };

  return (
    <I18nextProvider i18n={i18n}>
      <Router {...routerProps}>
        <AppRoutes />
      </Router>
    </I18nextProvider>
  );
}

export default App;
